import React, {Component} from 'react';
import { Link } from 'react-router'
import Auth from '../modules/Auth';

window.jQuery = window.$ = require('jquery');
window.$.velocity = require('velocity-animate/velocity.js')


class Navi extends Component {

  componentDidMount() {
    //this.menu_mobile = $(this.refs.menu_mobile);
    console.log('mount');
    //window.$('.dropdown-button').dropdown('open');
    window.$('.dropdown-button').dropdown({
      inDuration: 300,
      outDuration: 225,
      constrainWidth: true, // Does not change width of dropdown to that of the activator
      hover: false, // Activate on hover
      gutter: 0, // Spacing from edge
      belowOrigin: false, // Displays dropdown below the button
      alignment: 'left', // Displays dropdown with edge aligned to the left of button
      stopPropagation: false // Stops event propagation
    });

  }
  closeMenu(){

  }

  openMenu(){
    console.log('open mind');
  //  window.$('.dropdown-button').dropdown('open');



  }

  render(){
    var logout = '';
    var fbUserName = {name: ''};
    if(Auth.isUserAuthenticated()){
        logout = (<li><Link to="/logout">Salir</Link></li>);
    }
    if(Auth.isFacebookUser()){
    fbUserName = JSON.parse(Auth.getFacebookUser());
     if(fbUserName.email === undefined ){
        Auth.removeFacebookUser();
        window.location.reload();
     }
   }


    return(
    <nav className="green darken-1">
      <div className="nav-wrapper">
      <a href="#" className="brand-logo center">Enarm Simulator</a>
      <ul id="nav-mobile" className="left hide-on-med-and-down">
        <li><Link to="/">Home</Link></li>
        <li><Link to="/caso/1">Caso Clinico</Link></li>
        <li><Link to="/dashboard">Admin</Link></li>
        {logout}
      </ul>
      <ul className="right hide-on-med-and-down">
        <li><Link to="/profile">{fbUserName.name}</Link></li>
      </ul>
      <a data-activates="mobile-menu" onClick={this.openMenu.bind(this)} className="dropdown-button hide-on-large-only"><i className="material-icons">menu</i></a>

      <ul className="dropdown-content" id="mobile-menu">
        <li><Link to="/">Home</Link></li>
        <li><Link to="/caso/1">Caso Clinico</Link></li>
        <li><Link to="/dashboard">Admin</Link></li>
        {logout}
      </ul>
    </div>
  </nav>
    )
  }
}

export default Navi;



// WEBPACK FOOTER //
// ./src/components/Navi.js